import { get } from "lodash";

const getUserId = state => {
  return get(state, ["factoringClient", "user"]);
};

export default getUserId;
